export class ProdutoFoto {
  public id: number;
  public id_produto: number;
  public dt_ultima_atualizacao: Date;
  public imagem: string;
  public padrao: boolean;

  constructor() { }
}
